import changeCase from 'change-case-object'
import i18n from './index'

const attributeTranslator = {
  getTranslations: locale => {
    const translations = i18n[locale]

    // Take the translations and camel case the keys
    return Object.keys(translations)
      .filter(key => key !== key.toUpperCase())
      .map(key => {
        return {
          key: changeCase.camel(key),
          value: translations[key]
        }
      })
      .reduce((carry, translation) => {
        return Object.assign({ [translation.key]: translation.value }, carry)
      }, {})
  }
}

export default attributeTranslator
